import { ArrayLayoutProps, composePaths } from "@jsonforms/core";

export function getPaths(
  data: ArrayLayoutProps["data"],
  path: ArrayLayoutProps["path"]
) {
  return [...Array(data)].map((_, index) => ({
    path: composePaths(path, String(index)),
  }));
}

export function getMinItems(
  minItems: ArrayLayoutProps["minItems"],
  uischema: ArrayLayoutProps["uischema"]
) {
  return minItems ?? (uischema.options?.minItems || 0);
}

export function getLabel(
  uischema: ArrayLayoutProps["uischema"],
  label: ArrayLayoutProps["label"],
  defaultLabel: string
) {
  return label ?? uischema.options?.fieldErrorLabel ?? defaultLabel;
}

export function getItemName(
  uischema: ArrayLayoutProps["uischema"],
  label: ArrayLayoutProps["label"],
  defaultLabel: string
) {
  return uischema.options?.itemName ?? getLabel(uischema, label, defaultLabel);
}

export function getItemStyle(uischema: ArrayLayoutProps["uischema"]) {
  return uischema.options?.style;
}

export enum ItemStyle {
  CARD = "card",
}

export function getHasItemEditToggle(
  uischema: ArrayLayoutProps["uischema"],
  globalIsSummary: boolean | undefined
) {
  return !globalIsSummary && (uischema.options?.itemEditToggle ?? false);
}

export function matchesCondition(
  item: Record<string, unknown>,
  condition: Record<string, unknown>
) {
  return Object.entries(condition)
    .map(([field, value]) => item?.[field] === value)
    .every(Boolean);
}

export function getMatchingConditionDefinition(
  item: Record<string, unknown>,
  conditionDefinitions?: {
    condition: Record<string, unknown>;
    value: string;
    position?: "prefix" | "suffix" | "both";
  }[]
) {
  if (!conditionDefinitions || conditionDefinitions.length === 0) {
    return undefined;
  }
  return conditionDefinitions.find((conditionDefinition) =>
    matchesCondition(item, conditionDefinition.condition)
  );
}
